import React, { useState } from "react";
import pdf1 from "../../assets/dokumenty/PolitykaPrywatności.pdf";
import pdf2 from "../../assets/dokumenty/Prosbaoprzyjecie.pdf";
import pdf3 from "../../assets/dokumenty/Regulaminklub sportowyprzyfundacji.pdf";
import pdf4 from "../../assets/dokumenty/RegulaminStudia.pdf";

const FilesToDownload = () => {
  const [openFileId, setOpenFileId] = useState(null);

  // Sample list of files
  const files = [
    {
      id: 1,
      name: "Polityka Prywatności",
      url: pdf1,
    },
    {
      id: 2,
      name: "Prośba o przyjęcie",
      url: pdf2,
    },
    {
      id: 3,
      name: "Regulamin klubu sportowego przy fundacji",
      url: pdf3,
    },
    {
      id: 4,
      name: "Regulamin studia",
      url: pdf4,
    },
  ];

  // Function to handle file preview in a modal or container
  const handleOpen = (url) => {
    return (
      <iframe
        src={`${url}#toolbar=0&navpanes=0&scrollbar=0`}
        className="w-full h-[500px]"
        title="PDF Preview"
      />
    );
  };

  return (
    <div className="p-6 bg-gray-100 rounded-lg shadow-md">
      <h2 className="text-2xl font-bold mb-4">Pliki do przeglądania</h2>
      <ul className="space-y-4">
        {files.map((file) => (
          <li
            key={file.id}
            className="flex flex-col bg-white p-4 rounded-lg shadow-sm"
          >
            <div className="flex justify-between items-center">
              <span className="text-gray-700">{file.name}</span>
              <button
                onClick={() =>
                  setOpenFileId(openFileId === file.id ? null : file.id)
                }
                className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors"
              >
                {openFileId === file.id ? "Zamknij" : "Otwórz"}
              </button>
            </div>
            {openFileId === file.id && handleOpen(file.url)}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default FilesToDownload;
